import { call, put, takeLatest } from 'redux-saga/effects';
import { axiosInstance } from 'setup/axiosInstance';
import { feedbackActions } from 'features/feedback/store/feedback.slice';

export function* submitFeedbackSaga(
  action: ReturnType<typeof feedbackActions.submit>,
) {
  try {
    yield call(axiosInstance.post, '/feedback', action.payload);
    yield put(feedbackActions.submitSuccess());
  } catch (e) {
    console.error(e);
    const status = (e as { response?: { status?: number } })?.response?.status;
    const msg = status === 429 ? 'Забагато звернень. Спробуй трохи згодом.' : undefined;
    yield put(feedbackActions.submitError(msg));
  }
}

export default function* feedbackSaga() {
  yield takeLatest(feedbackActions.submit, submitFeedbackSaga);
}
